import http from "infra/http";
import { useQuery } from "react-query";
import { DocumentoPastaTreeItem } from "../typings";

function usePastasTree() {
  return useQuery(
    `/v1/documento/pastas-tree`,
    async () => {
      const { data } = await http.get<DocumentoPastaTreeItem[]>(`/v1/documento/pastas-tree`);

      return data;
    }
  );
}

export default usePastasTree;
